// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"f70283b9","171":"d04bb17d","365":"3889e398","507":"28641526","589":"26581081","801":"401e23d7","858":"cba6f526"}[chunkId] + ".chunk.js";
};